import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { find, remove, clone } from "lodash";

import LectureContent from "../../models/lecture-content.model";
import { LectureContentService } from "../../services/lecture-content.service";
import { DialogLectureContentComponent } from "../dialog-lecture-content/dialog-lecture-content.component";

import { Router } from "@angular/router";
import { Subject } from "rxjs";
import * as _ from "lodash";

@Component({
  selector: "ngx-view-lectures",
  styleUrls: ["./view-lectures.component.scss"],
  templateUrl: "./view-lectures.component.html",
})
export class ViewLecturesComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @Input() mode?: string = "home"; //home / tutor / review /

  submitted = false;
  loading = false;
  cursor: any;
  done = false;

  display?: LectureContent[] = [];
  lectures?: LectureContent[] = [];

  pageSize = 10;
  strSearch = "";
  uid = "anonymous";
  category = "all";

  constructor(
    private lectureService: LectureContentService,
    public userService: UserService,
    private dialogService: NbDialogService,
    private router: Router
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "anonymous";
        }
        this.getLectures();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getMore(): void {
    this.pageSize = 12;
    this.getLectures();
  }

  search() {
    this.strSearch = this.strSearch.toLowerCase();
  }

  report(item) {
    //
  }

  close() {}

  //Control event
  onSearch(): void {
    this.strSearch = this.strSearch.toLowerCase();

    this.display = this.lectures.filter(
      function (item) {
        return (
          item.title.toLowerCase().includes(this.title) ||
          item.description.toLowerCase().includes(this.title) ||
          item.tags.toString().toLowerCase().includes(this.strSearch)
        );
      },
      { title: this.strSearch }
    );
  }

  selectedCategory(item) {
    this.loading = true;
    this.category = item;
    switch (this.category) {
      case "all":
        this.display = [...this.lectures];
        break;
      case "approved":
        this.display = [...this.lectures];
        _.remove(this.display, (e) => {
          return e.isApproved == true;
        });
        break;
      case "unapproved":
        this.display = [...this.lectures];
        _.remove(this.display, (e) => {
          return e.isApproved == false;
        });
        break;
      default:
        this.display = [...this.lectures];
        break;
    }
    this.loading = false;
  }

  onNew() {
    let lecNew = new LectureContent();

    this.dialogService
      .open(DialogLectureContentComponent, {
        context: {
          header: "Tạo bài viết",
          mode: "new",
          lecture: lecNew,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.lectures = [value, ...this.lectures];
          this.display = [...this.lectures];
        }
      });
  }

  onEdit(item: LectureContent) {
    if (item) {
      for (let i = 0; i < this.lectures.length; i++) {
        if (this.lectures[i].id == item.id) {
          this.lectures[i] = item;
          break;
        }
      }
      this.display = [...this.lectures];
    }
  }

  onDelete(value) {
    if (value) {
      remove(this.lectures, (e) => {
        return e.id == value;
      });
      this.display = [...this.lectures];
    }
  }

  private getLectures(): void {
    this.loading = true;

    let subscribe: any;
    switch (this.mode) {
      case "tutor":
        subscribe = this.lectureService.getMyLectures(
          this.uid,
          this.pageSize,
          this.cursor
        );
        break;
      case "home":
        subscribe = this.lectureService.getPublishedLectures(
          this.pageSize,
          this.cursor
        );
        break;
      case "review":
        subscribe = this.lectureService.getReviewLectures(
          this.pageSize,
          this.cursor
        );
        break;
      default:
        subscribe = this.lectureService.getMyLectures(
          this.uid,
          this.pageSize,
          this.cursor
        );
        break;
    }

    subscribe
      .then((querySnapshot) => {
        if (querySnapshot.docs.length > 0) {
          this.cursor = querySnapshot.docs[querySnapshot.docs.length - 1];

          querySnapshot.forEach((doc) => {
            let data = new LectureContent();
            data = doc.data();
            data.id = doc.id;
            data.createdOn = convertTimestamp(doc.data().createdOn);

            let item = find(this.lectures, ["id", data.id]);
            if (item) {
              item = data;
            } else {
              this.lectures.push(data);
            }
          });

          this.display = [...this.lectures];

          console.log(
            `ViewLecturesComponent/${this.mode}/getLectures:`,
            this.display
          );
        } else {
          this.cursor = null;
          this.done = true;
        }

        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
  }
}
